import requests from "./httpService";

const TransferGatePassServices = {

  // =====================================================
  // GET ELIGIBLE TRANSFERS FOR GATE PASS
  //
  // Backend:
  // GET /transferGatePass/eligible
  // ?storeFrom=xxx&storeTo=xxx
  // =====================================================

  getEligibleTransfers: async (storeFrom, storeTo) => {

    const params = new URLSearchParams();

    if (storeFrom) {
      params.append("storeFrom", storeFrom);
    }

    if (storeTo) {
      params.append("storeTo", storeTo);
    }

    return requests.get(
      `/transferGatePass/eligible?${params.toString()}`
    );
  },


  // =====================================================
  // GENERATE GATE PASS
  //
  // Backend:
  // POST /transferGatePass/generate
  // =====================================================

  generateGatePass: async (body) => {
    return requests.post(
      `/transferGatePass/generate`,
      body
    );
  },

};

export default TransferGatePassServices;